export const ANONYMOUS_LOGIN_REQUESTED = 'ANONYMOUS_LOGIN_REQUESTED'
export const ANONYMOUS_LOGIN_SUCCEEDED = 'ANONYMOUS_LOGIN_SUCCEEDED'
export const ANONYMOUS_LOGIN_FAILED = 'ANONYMOUS_LOGIN_FAILED'
export const COUNTRY = 'COUNTRY'
export const LANGUAGE = 'LANGUAGE'